// extracted by mini-css-extract-plugin
export default {"container":"App_container__4L7Vo","header":"App_header__PKNxv","body":"App_body__00BrA"};